import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function DetailsRow(props) {
	return (
		<>
			<div className="form-group row ">
				<label className={!props.value1 ? `col-sm-12 col-form-label` : `col-sm-6 col-form-label`}>
					{props.label1}
				</label>

				<div className="col-sm-6 col-form-label">
					<span>{props.value1}</span>
				</div>
			</div>
		</>
	);
});
